import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Camille D.',
  location: 'Paris, France'
}, {
  name: 'Julien M.',
  location: 'Lyon, France'
}, {
  name: 'Élodie R.',
  location: 'Bordeaux, France'
}, {
  name: 'Thomas P.',
  location: 'Lille, France'
}, {
  name: 'Sophie L.',
  location: 'Nantes, France'
}, {
  name: 'Mathieu B.',
  location: 'Toulouse, France'
}, {
  name: 'Claire V.',
  location: 'Strasbourg, France'
}, {
  name: 'Antoine G.',
  location: 'Marseille, France'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    let dismissTimer: number | undefined;
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      dismissTimer = window.setTimeout(() => setVisible(false), 5500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
      if (dismissTimer) window.clearTimeout(dismissTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center animate-slide-in sm:left-auto sm:right-4 sm:justify-end" data-id="element-180" data-mp="1xmk80gyqwv83">
      <aside className="pointer-events-auto relative w-full max-w-[290px] overflow-hidden rounded-md border-2 border-brand-gold bg-brand-navy p-2.5 pr-8 shadow-[0_0_22px_rgba(201,163,74,0.65)]" aria-live="polite" data-id="element-181" data-mp="2qc9db6ihnhfi">
        <div className="absolute left-0 top-0 h-1 w-full bg-brand-gold" data-id="element-182" data-mp="2gdtnd6v76e7l" />
        <button onClick={() => setVisible(false)} aria-label="Fermer la notification" className="absolute right-1.5 top-1.5 text-white/70 transition-colors hover:text-white" data-id="element-183" data-mp="2ccrjudu8zfzt">
          <XIcon className="h-4 w-4" data-id="element-184" data-mp="10y4jmo7dgrwk" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-185" data-mp="10xcnnc9v4s5r">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-gold bg-brand-gold/15" data-id="element-186" data-mp="12fjonqs68vkx">
            <ShoppingBagIcon className="h-4 w-4 text-brand-gold" data-id="element-187" data-mp="17ee6apeeke3g" />
          </div>
          <div className="leading-tight text-white" data-id="element-188" data-mp="sglua782e7u0">
            <p className="text-xs font-extrabold" data-id="element-189" data-mp="xgq9zv15eyj6">{current.name}</p>
            <p className="text-[10px] font-bold text-white/70" data-id="element-190" data-mp="xevnwde550di">{current.location}</p>
            <p className="mt-0.5 text-[11px] font-extrabold text-brand-gold" data-id="element-191" data-mp="jojwkgpdr5nf">vient d’acheter KINÉ READY™</p>
          </div>
        </div>
      </aside>
    </div>;
}